import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Menu from './MainMenu';
import Box from '@mui/material/Box';
import { keyframes } from '@emotion/react';

import { Outlet, useLocation } from 'react-router-dom';
import GlobalSearch from './GlobalSearch';

const slideInFromTop = keyframes`
  0% { transform: translateY(-100%); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

const Layout = () => {
    const location = useLocation();
    const headerRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        localStorage.setItem('lastVisitedRoute', location.pathname);
    }, [location.pathname]);

    useLayoutEffect(() => {
        const el = headerRef.current;
        if (!el) return;

        const update = () => {
            const next = Math.ceil(el.getBoundingClientRect().height);
            setHeaderHeight(next);
        };

        update();

        let ro;
        if (typeof ResizeObserver !== 'undefined') {
            ro = new ResizeObserver(() => update());
            ro.observe(el);
        }

        window.addEventListener('resize', update);
        return () => {
            window.removeEventListener('resize', update);
            if (ro) ro.disconnect();
        };
    }, []);

    return (
        <>
            <Box
                ref={headerRef}
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    padding: { xs: '6px 8px', sm: '8px 16px' },
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    zIndex: 1000,
                    animation: `${slideInFromTop} 0.5s ease-out`,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    boxSizing: 'border-box',
                }}
            >
                <Box sx={{ width: '100%' }}>
                    <Menu />
                </Box>
            </Box>
            <Box sx={{ pt: `${headerHeight}px` }}>
                <Outlet />
            </Box>
            <GlobalSearch />
        </>
    );
};

export default Layout;
